import { createRoot } from "react-dom/client";
// Axios
import axios from "axios";
import { Chart, registerables } from "chart.js";
import { QueryClient, QueryClientProvider } from "react-query";
// Apps
import { MetronicI18nProvider } from "./_private/i18n/Metronici18n";
import "./_private/assets/fonticon/fonticon.css";
import "./_private/assets/keenicons/duotone/style.css";
import "./_private/assets/keenicons/outline/style.css";
import "./_private/assets/keenicons/solid/style.css";
import "react-toastify/dist/ReactToastify.css";
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/

import "./_private/assets/sass/style.scss";
import "./_private/assets/css/style.css"
import "./_private/assets/sass/plugins.scss";
import "./_private/assets/sass/style.react.scss";
import { AppRoutes } from "./app/routing/AppRoutes";
import { AuthProvider, setupAxios } from "./app/modules/auth";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import reduxStore from "../src/redux/store";
import "./app/pages/style.css";
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

import "react-dropdown/style.css";
setupAxios(axios);
Chart.register(...registerables);

const queryClient = new QueryClient();
const { store, persistor } = reduxStore();

// if (window.location.origin === "https://sphq.plxmed.com") {
// 	// 🚫 Disable React DevTools
// 	const w = window as any; // 👈 cast to any
// 	if (typeof w.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object") {
// 		for (const key in w.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
// 			w.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] =
// 				typeof w.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] === "function"
// 					? () => { }
// 					: null;
// 		}
// 	}

// 	// 🚫 Disable right-click
// 	document.addEventListener("contextmenu", (e) => e.preventDefault());

// 	// 🚫 Block common DevTools shortcuts
// 	document.onkeydown = (e) => {
// 		if (
// 			e.key === "F12" || // F12
// 			(e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) || // Ctrl+Shift+I/J/C
// 			(e.ctrlKey && e.key === "U") // Ctrl+U (view source)
// 		) {
// 			e.preventDefault();
// 			return false;
// 		}
// 	};
// }

const container = document.getElementById("root");
if (container) {
	createRoot(container).render(

		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<QueryClientProvider client={queryClient}>
					<MetronicI18nProvider>
						<AuthProvider>
							<AppRoutes />
						</AuthProvider>
					</MetronicI18nProvider>
					{/* <ReactQueryDevtools initialIsOpen={false} /> */}
				</QueryClientProvider>
			</PersistGate>
		</Provider>

	);
}
